import http from '../../services/http-common';

class FullPropertyService {
  getFullPropertyForList(id) {
    return http.get(`/FullProperty/sp/list/${id}`);
  }
  insert(data) {
    return http.post(`/FullProperty/db/add`, data);
  }
  update(data) {
    return http.put(`/FullProperty/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/FullProperty/db/delete/${PropertyID}`);
  }
}

export default new FullPropertyService();